module.exports = __webpack_public_path__ + "img/Visa.f37db3f3.png";